import * as React from 'react'
import '../styles/App.scss'
import { FlatButton } from 'material-ui'
import { AppBarContainer } from './CustomAppBar'
import PageTitle from '../components/PageTitle'
import { DEFAULT_ROUTE, ROUTES } from '../constants/routes'
import { Api } from '../services/api/api'
import { StoreState } from '../reducers'
import { RouterAction, routerActions } from 'react-router-redux'
import { connect, Dispatch } from 'react-redux'
import { ClientInfo, TermsArray } from '../types'
import { Actions as SignInActions, ActionType as SignInActionType } from '../actions/signIn'
import { ActionType as UserActionType } from '../actions/user'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { ActionType as ErrorInfoActionType, Actions as ErrorActions } from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'

import TermsUtils from '../utils/TermsUtils'

interface TermsProps {
  routePush: (location: string) => RouterAction
  client: ClientInfo
  updateUser: (client: ClientInfo) => SignInActionType
  onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
}

interface TermsStates {
  termsLinks: TermsArray[]
  link: string
  termsAccepted: number,
  isButtonDisabled: boolean
}

class Terms extends React.Component<TermsProps, TermsStates> {
  constructor(props) {
    super(props)
    this.state = {
      termsLinks: [],
      link: '',
      termsAccepted: 0,
      isButtonDisabled: true
    }
  }

  componentDidMount() {
    Api.getTerms()
      .then((result: TermsArray[]) => {
        if (result && result.length !== 0) {
          let index = result.findIndex(term => term.isAccepted === false)
          if (index === -1) {
            console.log('All terms accepted!')
            this.allTermsAccpeted()
          } else {
            this.setState({
              termsLinks: result,
              termsAccepted: index,
              link: result[index].link,
              isButtonDisabled: false
            })
          }
        }
      })
      .catch(error => {
        this.props.onErrorEvent(Mapper.mapError(error))
      })
  }

  declineTerms = () => {
    this.props.routePush(ROUTES.LOG_OUT)
  }

  agreeTerms = () => {
    this.setState({
      isButtonDisabled: true
    })

    Api.acceptTerms(this.state.termsLinks[this.state.termsAccepted].id)
      .then(() => {
        let i: number = this.state.termsAccepted + 1
        if (i === this.state.termsLinks.length) {
          this.allTermsAccpeted()
        } else {
          for (i; i < this.state.termsLinks.length; i++) {
            if (this.state.termsLinks[i].isAccepted !== true) {
              this.setState({
                termsAccepted: i,
                link: this.state.termsLinks[i].link,
                isButtonDisabled: false
              })
              return
            } else {
              this.allTermsAccpeted()
            }
          }
        }
      })
      .catch(error => {
        this.setState({
          isButtonDisabled: false
        })
        this.props.onErrorEvent(Mapper.mapError(error))
      })
  }

  allTermsAccpeted = () => {
    let clientInfo: ClientInfo = { ...this.props.client }
    clientInfo.isTermsAccepted = true
    Api.setClientInfo(clientInfo)
      .then(() => {
        this.props.updateUser(clientInfo)
        this.props.routePush(DEFAULT_ROUTE)
      })
      .catch(error => {
        console.log(error)
        this.declineTerms()
      })
  }

  getSrc = () => {
    if (this.state.termsLinks.length !== 0) {
      let link = encodeURIComponent(this.state.link)
      let src = TermsUtils.getSrc(link)
      return src
    } else return ``
  }

  render() {
    return (
      <BaseContainer pageName={EventType.TERMS}>
        <AppBarContainer
          isIconButtonsShown={false}
          isMenuShown={false}
        />
        <PageTitle text={StringResources.getString(Strings.TermsConditions.Title)} />
        <div className="iframeContainer">
          <iframe src={'https://curb-it.com/terms'} />
        </div>
        <div className="bottom-part hover">
          <FlatButton
            label={StringResources.getString(Strings.TermsConditions.Buttons.Decline.label)}
            className={this.state.isButtonDisabled ? 'flatbutton disabled' : 'flatbutton'}
            onClick={this.declineTerms}
            disabled={this.state.isButtonDisabled}
          />
          <FlatButton
            label={StringResources.getString(Strings.TermsConditions.Buttons.Agree.label)}
            className={this.state.isButtonDisabled ? 'flatbutton disabled' : 'flatbutton'}
            onClick={this.agreeTerms}
            disabled={this.state.isButtonDisabled}
          />
        </div>
      </BaseContainer>
    )
  }
}

function mapStateToProps(state: StoreState) {
  return {
    client: state.auth.user
  }
}

function mapDispatchToProps(dispatch: Dispatch<RouterAction | UserActionType>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    updateUser: (client: ClientInfo) => dispatch(SignInActions.authorize(client)),
    onErrorEvent: (errorInfo: ErrorInfo) => dispatch(ErrorActions.newError(errorInfo))
  }
}

export const TermsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Terms)



// WEBPACK FOOTER //
// ./src/containers/Terms.tsx